<template>
  <b-modal
    :width="width"
    :active.sync="isShowModalSync"
    :on-cancel="cancel"
    :can-cancel="canCancel"
    v-if="isShowModalSync">
    <div class="card -card">
      <header class="card-header -header" v-if="title">
        <p class="card-header-title title">
          {{title}}
        </p>
      </header>
      <slot></slot>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'BasicModal',
  componentName: 'BasicModal',
  props: {
    title: {
      type: String,
      required: false
    },
    isShowModal: {
      type: Boolean,
      required: false,
      default: false
    },
    canCancel: {
      type: Boolean
    },
    width: {
      type: String,
      'default': () => ('680px')
    }
  },
  watch: {
    isShowModal () {
      this.isShowModalSync = this.isShowModal
    }
  },
  data () {
    return {
      isShowModalSync: this.isShowModal
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.-card {
  width: 100%;
  border-radius: 8px;
}
.-header {
  width: 100%;
  p {
    display: block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Modals/BasicModal.vue